export { TooltipModule } from "./src/tooltip.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-tooltips/index.js
// module id = 425
// module chunks = 21